import React, { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Color } from '../../../../enums/color'
import { Icon } from '../../../Icon'
import { Text } from '../../../Text'
import * as Styled from './styles'

interface DropzoneContentProps {
  blockedText?: ReactNode
  contentText?: ReactNode
  customFooterElement?: ReactNode
  disabled?: boolean
  footerText?: ReactNode
  isBlocked?: boolean
  isDragActive?: boolean
  isUploading?: boolean
  uploadingText?: ReactNode
}

export const DropzoneContent = ({
  blockedText,
  contentText,
  customFooterElement,
  disabled = false,
  footerText,
  isBlocked,
  isDragActive,
  isUploading,
  uploadingText,
}: DropzoneContentProps): ReactElement => {
  const { t } = useTranslation()

  const footerElement = customFooterElement || (
    <Text variant="bodySM" colorVariant={disabled ? 'disable' : 'secondary'}>
      {footerText || t('ds.dropzone.click_to_upload')}
    </Text>
  )

  let element = (
    <>
      <Text colorVariant={disabled ? 'disable' : 'primary'} weight="medium">
        {contentText || t('ds.dropzone.drag_here')}
      </Text>
      {footerElement}
    </>
  )

  if (isUploading) {
    element = <Text colorVariant={disabled ? 'disable' : 'primary'}>{uploadingText || t('ds.dropzone.uploading')}</Text>
  }

  if (isBlocked) {
    element = <Text weight="medium">{blockedText || t('ds.dropzone.blocked')}</Text>
  }

  return (
    <>
      <Styled.ImageWrapper uploading={isUploading}>
        <Icon icon="uploadCloud" size="lg" color={Color.Grey800} />
      </Styled.ImageWrapper>
      <Styled.Footer>{element}</Styled.Footer>
    </>
  )
}
